import React, { useEffect, useState } from "react";
import "./Coms.css";

import { ComsPageProps } from "../../../models/coms.model";
import { SOCIAL_LINKS } from "../../../constants/coms.constants";
import { usePrivacyScrollLock } from "../../../hooks/usePrivacyScrollLock";
import { ComsLayers } from "./ComsLayers";
import { ComsFooter } from "./ComsFooter";
import { PrivacyModal } from "../../modals/PrivacyModal";
import { ParallaxLayer } from "@react-spring/parallax";

const ComsPage: React.FC<ComsPageProps> = ({ offset, isFirstVisit, onPrivacyOpenChange }) => {
	const [showPrivacy, setShowPrivacy] = useState(false);
	const [showExclamation, setShowExclamation] = useState(false);

	// inform parent of modal open state
	useEffect(() => {
		onPrivacyOpenChange(showPrivacy);
	}, [showPrivacy, onPrivacyOpenChange]);

	// delay exclamation if first visit
	useEffect(() => {
		if (!isFirstVisit) return;
		const timer = setTimeout(() => setShowExclamation(true), 1_000);
		return () => clearTimeout(timer);
	}, [isFirstVisit]);

	// lock background scroll when privacy open
	usePrivacyScrollLock(showPrivacy);

	return (
		<div
			className="coms-container"
			style={{ "--offset": offset } as any}
		>
			<ComsLayers
				offset={offset}
				isFirstVisit={isFirstVisit}
				showExclamation={showExclamation}
			/>

			<ComsFooter
				onPrivacyClick={() => setShowPrivacy(true)}
				socialLinks={SOCIAL_LINKS}
			/>
			<ParallaxLayer
				offset={0}
				style={{ zIndex: 20, pointerEvents: "auto" }}
			>
				<PrivacyModal
					open={showPrivacy}
					onClose={() => setShowPrivacy(false)}
				/>
			</ParallaxLayer>
		</div>
	);
};

export default ComsPage;
